import DataLayer from '../domains/data-layer.dto'

export default class HigiaGtmService {
    dataLayerHigia = DataLayer.getInstance('', '', '', '', '', '', '')
    public static EVENTS = {
        FORM_VALIDATION_ERROR: 'form-validation-error',
        ERROR_SERVICE: 'error-service',
        AUTHENTICATION_ERROR: 'authentication-error',
    }

    public static TYPE = {
        HTML: 'html',
        SERVICE: 'service',
        NAVIGATION: 'navigation',
    }

    public static STATUS = {
        ERROR: 'error',
        SUCESS: 'sucess',
    }

    janela: any = window
    public setDataLayer(dataLayer: DataLayer) {
        this.janela.dataLayer = this.janela.dataLayer ? this.janela.dataLayer : []
        this.janela.dataLayer.push({
            event: dataLayer.event,
            userId: dataLayer.userId,
            type: dataLayer.type,
            msg: dataLayer.msg,
            status: dataLayer.status,
            vpageurl: dataLayer.vpageurl,
            data: dataLayer.data,
        })
    }
}
